import { createEmbedBlockHtmlAdapterMatcher } from '@blocksuite/hive-block-embed';
import { BookmarkBlockSchema } from '@blocksuite/hive-model';
import { BlockHtmlAdapterExtension } from '@blocksuite/hive-shared/adapters';

export const bookmarkBlockHtmlAdapterMatcher =
  createEmbedBlockHtmlAdapterMatcher(BookmarkBlockSchema.model.flavour);

export const BookmarkBlockHtmlAdapterExtension = BlockHtmlAdapterExtension(
  bookmarkBlockHtmlAdapterMatcher
);
